import React, { useLayoutEffect, useRef, useState } from 'react'
import styles from './CollapseItem.module.css'

const LEAVE_MS = 340

const CollapseItem = ({
    leaving = false,
    highlight = false,
    gap = '0px',
    onLeft,
    className = '',
    style,
    children,
    ...rest
}) => {
    const ref = useRef(null)
    const [collapsed, setCollapsed] = useState(false)
    const onLeftRef = useRef(onLeft)
    onLeftRef.current = onLeft

    useLayoutEffect(() => {
        const el = ref.current
        if (!leaving || !el) return undefined
        el.style.boxSizing = 'border-box'
        el.style.height = `${el.offsetHeight}px`
        el.getBoundingClientRect()
        el.style.height = '0px'
        setCollapsed(true)
        const done = setTimeout(() => onLeftRef.current?.(), LEAVE_MS)
        return () => clearTimeout(done)
    }, [leaving])

    return (
        <div
            ref={ref}
            className={`${styles.item} ${
                highlight ? styles.highlight : ''
            } ${collapsed ? styles.leaving : ''} ${className}`}
            style={{ '--collapse-gap': gap, ...style }}
            data-leaving={leaving ? '' : undefined}
            {...rest}
        >
            {children}
        </div>
    )
}

export default CollapseItem
